import { render } from "./QuranPrograms.vue?vue&type=template&id=bcd8bbd2&scoped=true"
import script from "./QuranPrograms.vue?vue&type=script&lang=js"
export * from "./QuranPrograms.vue?vue&type=script&lang=js"

import "./QuranPrograms.vue?vue&type=style&index=0&id=bcd8bbd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcd8bbd2"]])

export default __exports__